import React from 'react';

import { Col, Row, VertPagination } from '@vertem-core/vertice-ds';

import "Assets/styles/default/components/Pagination/Pagination.less";

import PropTypes from 'prop-types';

const Pagination = ({
  current=1, total=50, pageSize=12, callback,
}) => {
  return (
    <Row className="pagination-container" justify="center" align="middle">
      <Col>
        <VertPagination
          defaultCurrent={1}
          current={current}
          simple={false}
          total={total}
          onChange={callback}
          showSizeChanger={false}
          pageSize={pageSize}
          showLessItems
        />
      </Col>
    </Row>
  );
};

Pagination.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
  pageSize: PropTypes.number,
  callback: PropTypes.func,
};

export default Pagination;
